(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initGallery();
    initVariantPicker();
    initTabs();
    initFAQ();
  }

  /* ── Image Gallery ── */
  /* The gallery is a horizontal scroll-snap track, so swiping is native.
     Thumbnails and dots drive scrollLeft; scrolling drives which one is
     highlighted. Nothing here swaps a src, so slides never flicker. */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide-index]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb-index]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot-index]'));
    if (!slides.length) return;

    function markActive(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb-index'), 10) === index);
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-dot-index'), 10) === index);
      });
    }

    // While a click-driven scroll is animating, the scroll handler must not
    // re-mark whatever slide happens to be passing by — otherwise the target
    // gets overwritten mid-flight and the wrong thumb ends up highlighted.
    var settling = null;

    function goTo(index) {
      var slide = slides.filter(function (sl) {
        return parseInt(sl.getAttribute('data-slide-index'), 10) === index;
      })[0];
      if (!slide) return;

      markActive(index);
      if (settling) clearTimeout(settling);
      settling = setTimeout(function () { settling = null; }, 700);

      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    // Exposed so the variant picker can move the gallery too.
    gallery.__goToSlide = goTo;
    gallery.__slides = slides;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-thumb-index'), 10));
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-dot-index'), 10));
      });
    });

    // A swipe updates the active thumb/dot. rAF-throttled so a fast flick does
    // not fire hundreds of layout reads.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (settling) return; // a click is driving the scroll; leave its mark alone
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var mid = track.scrollLeft + track.clientWidth / 2;
        var nearest = slides[0];
        var best = Infinity;
        slides.forEach(function (sl) {
          var centre = sl.offsetLeft - track.offsetLeft + sl.clientWidth / 2;
          var d = Math.abs(centre - mid);
          if (d < best) { best = d; nearest = sl; }
        });
        markActive(parseInt(nearest.getAttribute('data-slide-index'), 10));
      });
    }, { passive: true });

    // Arrow-key support for the focusable track.
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var order = slides.map(function (sl) { return parseInt(sl.getAttribute('data-slide-index'), 10); });
      var active = dots.concat(thumbs).filter(function (el) { return el.classList.contains('is-active'); })[0];
      var current = active
        ? parseInt(active.getAttribute('data-dot-index') || active.getAttribute('data-thumb-index'), 10)
        : order[0];
      var pos = order.indexOf(current);
      var next = e.key === 'ArrowRight' ? Math.min(pos + 1, order.length - 1) : Math.max(pos - 1, 0);
      goTo(order[next]);
    });

    markActive(parseInt(slides[0].getAttribute('data-slide-index'), 10));
  }

  /* ── Variant Picker ── */
  function initVariantPicker() {
    var form = document.querySelector('.harrington-form');
    if (!form) return;

    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    var product = JSON.parse(productJson.textContent);
    var variantInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var selectedOptions = {};

    product.options.forEach(function (opt, i) {
      var select = form.querySelector('[data-option-select="' + (i + 1) + '"]');
      if (select) selectedOptions[i] = select.value;
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      variantInput.value = variant.id;

      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-default-text') || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }

      if (variant.featured_image) {
        // Scroll the gallery to this variant's photo instead of overwriting the
        // first slide's src — that kept the other images from being swipeable.
        var galleryEl = document.querySelector('[data-gallery]');
        var wanted = variant.featured_image.src.replace(/(\?.*)?$/, '');
        if (galleryEl && galleryEl.__goToSlide && galleryEl.__slides) {
          var match = galleryEl.__slides.filter(function (sl) {
            var src = sl.getAttribute('data-slide-src') || '';
            return src && (wanted.indexOf(src) > -1 || src.indexOf(wanted) > -1);
          })[0];
          if (match) galleryEl.__goToSlide(parseInt(match.getAttribute('data-slide-index'), 10));
        }
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return (cents / 100).toFixed(2);
    }

    if (addBtn) {
      addBtn.setAttribute('data-default-text', addBtn.textContent.trim());
    }

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = parseInt(btn.getAttribute('data-option-position'), 10);
        var value = btn.getAttribute('data-option-value');
        selectedOptions[position - 1] = value;

        var select = form.querySelector('[data-option-select="' + position + '"]');
        if (select) select.value = value;

        var picker = btn.closest('[data-option-picker]');
        if (picker) {
          picker.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');

          var label = picker.querySelector('[data-selected-option="' + position + '"]');
          if (label) label.textContent = value;
        }

        var variant = findVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  /* ── Tabs ── */
  function initTabs() {
    var container = document.querySelector('[data-tabs]');
    if (!container) return;

    var btns = container.querySelectorAll('[data-tab-btn]');
    var panels = container.querySelectorAll('[data-tab-panel]');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-tab-btn');

        btns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = container.querySelector('[data-tab-panel="' + index + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    var items = document.querySelectorAll('[data-faq-toggle]');
    if (!items.length) return;

    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.harrington-faq__item');
        var isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.harrington-faq__item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
})();